const fields = [
  {
    uid: 'salary',
    type: 'number',
    label: 'Annual Salary',
    defaultValue: '',
    value: '$50,000',
    pattern: '[0-9]*',
    maxLength: 9,
  },
  {
    uid: 'period',
    type: 'string',
    label: 'Pay Period',
    placeholder: 'How often are you paid?',
    options: [
      {
        uid: 'daily',
        content: 'Daily',
        occurrences: 365,
      },
      {
        uid: 'weekly',
        content: 'Weekly',
        occurrences: 52,
      },
      {
        uid: 'biweekly',
        content: 'Biweekly',
        occurrences: 26,
      },
      {
        uid: 'semimonthly',
        content: 'Semimonthly',
        occurrences: 24,
      },
      {
        uid: 'monthly',
        content: 'Monthly',
        occurrences: 12,
      },
      {
        uid: 'quarterly',
        content: 'Quarterly',
        occurrences: 4,
      },
      {
        uid: 'semiannual',
        content: 'Semiannual',
        occurrences: 2,
      },
      {
        uid: 'annual',
        content: 'Annual',
        occurrences: 1,
      },
    ],
    defaultValue: '',
    value: 'Biweekly',
  },
  {
    uid: 'status',
    type: 'string',
    label: 'Filing Status',
    options: [
      {
        uid: 'single',
        content: 'Single',
      },
      {
        uid: 'married',
        content: 'Married',
      },
    ],
    defaultValue: '',
    value: 'Single',
  },
  {
    uid: 'exemptions',
    type: 'number',
    label: 'Exemptions',
    options: [
      { uid: 0, content: 0 },
      { uid: 1, content: 1 },
      { uid: 2, content: 2 },
      { uid: 3, content: 3 },
      { uid: 4, content: 4 },
      { uid: 5, content: 5 },
      { uid: 6, content: 6 },
      { uid: 7, content: 7 },
      { uid: 8, content: 8 },
      { uid: 9, content: 9 },
      { uid: 10, content: 10 },
    ],
    defaultValue: '',
    value: 1,
  },
  {
    uid: 'deferrals',
    type: 'number',
    label: '% Retirement Contribution',
    options: [
      { uid: 1, content: '1%' },
      { uid: 2, content: '2%' },
      { uid: 3, content: '3%' },
      { uid: 4, content: '4%' },
      { uid: 5, content: '5%' },
      { uid: 6, content: '6%' },
      { uid: 7, content: '7%' },
      { uid: 8, content: '8%' },
      { uid: 9, content: '9%' },
      { uid: 10, content: '10%' },
      { uid: 11, content: '11%' },
      { uid: 12, content: '12%' },
      { uid: 13, content: '13%' },
      { uid: 14, content: '14%' },
      { uid: 15, content: '15%' },
      { uid: 16, content: '16%' },
      { uid: 17, content: '17%' },
      { uid: 18, content: '18%' },
      { uid: 19, content: '19%' },
      { uid: 20, content: '20%' },
      { uid: 21, content: '21%' },
      { uid: 22, content: '22%' },
      { uid: 23, content: '23%' },
      { uid: 24, content: '24%' },
      { uid: 25, content: '25%' },
    ],
    defaultValue: '',
    value: '5%',
  },
];

export default fields;



// WEBPACK FOOTER //
// ./src/config/fields.js